var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.33333C16.1254 7.33333 17.5243 7.91279 18.5557 8.94424C19.5872 9.97569 20.1667 11.3746 20.1667 12.8333V19.25H16.5V12.8333C16.5 12.3471 16.3068 11.8808 15.963 11.537C15.6192 11.1931 15.1529 11 14.6667 11C14.1804 11 13.7141 11.1931 13.3703 11.537C13.0265 11.8808 12.8333 12.3471 12.8333 12.8333V19.25H9.16666V12.8333C9.16666 11.3746 9.74612 9.97569 10.7776 8.94424C11.809 7.91279 13.208 7.33333 14.6667 7.33333Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49999 8.24999H1.83333V19.25H5.49999V8.24999Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66666 5.49999C4.67918 5.49999 5.49999 4.67918 5.49999 3.66666C5.49999 2.65414 4.67918 1.83333 3.66666 1.83333C2.65414 1.83333 1.83333 2.65414 1.83333 3.66666C1.83333 4.67918 2.65414 5.49999 3.66666 5.49999Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e289b92b04a58251612ea66794cac025.svg";
export { ForwardRef as ReactComponent };